import { gql } from "@apollo/client/core";
import { BASEMODEL_FRAGMENT } from "./base-definition";
import { DELETION_RESPONSE_FRAGMENT } from "./system-definition";

export const TRADING_SET_RELATION_FIELDS_FRAGMENT = gql`
fragment TradingSetRelation on TradingSetRelation {
    ...IBaseModel
    parentProductId
    childProductId
    quantity
    manualSalesPricePerItem
    manualCostsPricePerItem
    #for now minimal data
    childProduct {
        id
        identifier
        version
        description
        addition
        productType
        calculatoryCosts
        lastPurchasePrice
        averagePurchasePrice
        unit {
            id
            identifier
            description
        }
    }
    order
}
${BASEMODEL_FRAGMENT}
`;

export const TRADING_SET_PRICE_INFO_FIELDS_FRAGMENT = gql`
fragment TradingSetPriceInfo on TradingSetPriceInfo {
    priceList {
        identifier
        description
        currency
        priceIncludesTax
    }
    setPriceItems
    revenueItems
    setPriceHeader
    revenueHeader
    setPriceDifference
    revenueDifference
}
`;

export const GET_TRADING_SET_RELATION = gql`
query GetTradingSetRelation($id:String!) {
    getTradingSetRelation(id: $id) {
        ...TradingSetRelation
    }
}
${TRADING_SET_RELATION_FIELDS_FRAGMENT}
`;

export const GET_TRADING_SET_RELATIONS = gql`
query GetTradingSetRelations($input:TradingSetRelationSearchInput) {
    getTradingSetRelations(input: $input) {
        totalItems
        items {
            ...TradingSetRelation
        }
    }
}
${TRADING_SET_RELATION_FIELDS_FRAGMENT}
`;

export const GET_TRADING_SET_PRICE_INFO = gql`
query GetTradingSetPriceInfo($tradingSetId: String!, $searchInput: TradingSetPriceInfoSearchInput) {
    getTradingSetPriceInfo(tradingSetId: $tradingSetId, searchInput: $searchInput) {
        ...TradingSetPriceInfo
    }
}
${TRADING_SET_PRICE_INFO_FIELDS_FRAGMENT}
`;

export const SAVE_TRADING_SET_RELATION = gql`
mutation SaveTradingSetRelation($input: TradingSetRelationInput!) {
    saveTradingSetRelation(input: $input){
        ...TradingSetRelation
    }
}
${TRADING_SET_RELATION_FIELDS_FRAGMENT}
`;

export const SAVE_TRADING_SET_RELATIONS = gql`
mutation SaveTradingSetRelations($input: [TradingSetRelationInput!]!) {
    saveTradingSetRelations(input: $input){
        ...TradingSetRelation
    }
}
${TRADING_SET_RELATION_FIELDS_FRAGMENT}
`;

export const DELETE_TRADING_SET_RELATION = gql`
mutation DeleteTradingSetRelation($id: String!) {
    deleteTradingSetRelation(id: $id) {
        ... DeletionResponse
    }
}
${DELETION_RESPONSE_FRAGMENT}
`;
